<template>
  <div ref="menuElemRef" class="context-menu">
    <button type="button" class="context-menu__icon" @click="toggleMenuHandler">
      <slot>
        <SvgIcon icon="dots" />
      </slot>
    </button>
    <Transition name="dropdown">
      <div
        v-show="isOpen"
        class="context-menu__wrapper"
        :class="[
          openTop ? 'context-menu__wrapper_position_top' : 'context-menu__wrapper_position_bottom',
        ]"
      >
        <ul class="context-menu__items">
          <li
            v-for="i in items"
            :key="JSON.stringify(i)"
            class="context-menu__item"
            @click.prevent="i.callback ? handleClick(i.callback) : null"
          >
            <component
              :is="i.route ? 'RouterLink' : 'span'"
              :to="i.route"
              :class="[i.color, { link: i.route }]"
            >
              <SvgIcon v-if="i.icon" :icon="i.icon" size="18" />
              <span>{{ i.title }}</span>
            </component>
          </li>
        </ul>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import type { MenuItem } from '@/types/lists'
import SvgIcon from '@/components/SvgIcon.vue'

const props = defineProps<{
  items: MenuItem[]
  item?: unknown
}>()

const isOpen = ref<boolean>(false)
const openTop = ref<boolean>(false)
const clickY = ref<number>(0)
const windowHeight = ref<number>(window.innerHeight)
const menuElemRef = ref<HTMLDivElement | null>(null)

const close = () => {
  if (isOpen.value) isOpen.value = false
}

onClickOutside(menuElemRef, close)

const toggleMenuHandler = (event: MouseEvent): void => {
  isOpen.value = !isOpen.value
  clickY.value = event.clientY

  openTop.value = windowHeight.value / 2 < clickY.value
}

const handleClick = (callback: (item?: unknown) => void): void => {
  if (props.item) {
    callback(props.item)
  } else {
    callback()
  }
  close()
}

defineExpose({ toggleMenuHandler })
</script>

<style scoped lang="scss">
.context-menu {
  position: relative;
  display: flex;
  align-items: center;

  &__item {
    span {
      display: flex;
      align-items: center;
      gap: 8px;
      white-space: nowrap;
      svg {
        min-width: 18px;
      }
    }
    padding: 10px;
    cursor: pointer;
    @include hover(background-color, $bgGrey);

    .link {
      color: $black100;
      &:visited {
        color: $black100;
      }
    }

    .red {
      color: $red;
    }
  }

  &__wrapper {
    min-width: 155px;
    position: absolute;
    z-index: 15;
    background-color: $white;
    box-shadow: $shadow;
    border-radius: 10px;
    overflow: hidden;
    right: -8px;

    &_position_top {
      bottom: calc(100% + 7px);
    }

    &_position_bottom {
      top: calc(100% + 7px);
    }
  }

  &__items {
    //transition: opacity 0.2s ease;
    display: flex;
    flex-direction: column;
    width: 100%;

    // &.menu-open {
    //   opacity: 1;
    //   pointer-events: auto;
    // }
  }
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition:
    opacity 140ms ease,
    transform 160ms cubic-bezier(0.16, 1, 0.3, 1);
  transform-origin: top;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-4px) scaleY(0.98);
}

.dropdown-enter-to,
.dropdown-leave-from {
  opacity: 1;
  transform: translateY(0) scaleY(1);
}
</style>
